import type { ReactElement } from 'react'
import { CheckCircle, Error as ErrorIcon, Info, Warning } from '@mui/icons-material'

type ToastSeverity = 'success' | 'error' | 'warning' | 'info'

const TOAST_ICON_MAPPING: Record<ToastSeverity, ReactElement> = {
  success: <CheckCircle fontSize="inherit" />,
  error: <ErrorIcon fontSize="inherit" />,
  warning: <Warning fontSize="inherit" />,
  info: <Info fontSize="inherit" />,
}

export type { ToastSeverity }
export { TOAST_ICON_MAPPING }
